import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { PageContainer } from 'components';
import { useQuery } from 'hooks';
import createToast from 'components/Toast/Toast';
import { useNavigate, useLocation } from 'react-router-dom';
import DigitalAccountsServices from '../DigitalAccountServices';
import { Wallet } from './components';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const DigitalAccount = () => {
  // -- STATES --//
  const [accountDetails, setAccountDetails] = useState({
    wallets: [],
    blocks: [],
    guilds: [],
  });
  const [loading, setLoading] = useState(false);
  const actionsList =
    getDynamicObjectAction([
      'contentAccountsDigitalPage',
      'accountWalletDashboardBtn',
      'contentImprestAccountsDigitalPage'

    ])
  // -- HOOKS --//
  const classes = useStyles();
  const naviagte = useNavigate();
  const query = useQuery();
  const paid = query.get('paid');
  const currentLoaction = useLocation();

  useEffect(() => {
    if (String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? (actionsList['contentImprestAccountsDigitalPage']) : (actionsList['contentAccountsDigitalPage'] || actionsList['accountWalletDashboardBtn'])) {
      if (paid) {
        if (paid.toLowerCase() === 'true') {
          createToast('موفق', 'شارژ حساب دیجیتال با موفقیت انجام شد.', 'success');
          query.delete('paid');
          naviagte({
            search: query.toString(),
          });
        }

        if (paid.toLowerCase() === 'false') {
          createToast('خطا', 'شارژ حساب دیجیتال ناموفق.', 'danger');
          query.delete('paid');
          naviagte({
            search: query.toString(),
          });
        }
      }
      (async () => {
        try {
          setLoading(true);
          const result = await DigitalAccountsServices.credit();
          setAccountDetails({
            blocks: result.result.blockAmountSrvs,
            wallets: result.result.customerAmountSrvs,
            guilds: result.result.mainBusinessAmountSrvs,
          });
          setLoading(false);
        } catch (error) {
          setLoading(false);

        }
      })();
    }

  }, []);

  const hintText =
    'اطلاعات حساب دیجیتال شما به همراه جزئیات در زیر نمایش داده شده است. از حساب دیجیتال می‌توانید در کسب‌وکارهای دیگر هزینه کنید یا موجودی آن را برداشت نمایید.';

const getKeyBreadCrumbsWithUrl = () => {
  if (!currentLoaction?.pathname) return null;

  return currentLoaction.pathname.toUpperCase().includes('IMPREST')
    ? constBreadCrumbsTitle.IMPREST_ACCOUNTS
    : constBreadCrumbsTitle.BFO_ACCOUNTS;
};

  return (
    <PageContainer
      title="حساب دیجیتال من"
      className={classes.root}
      description={hintText}
      breadcrumbs={getKeyBreadCrumbsWithUrl(currentLoaction, 'IMPREST')}
      loading={loading}
    >
      {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? (actionsList['contentImprestAccountsDigitalPage']) : (actionsList['contentAccountsDigitalPage'] || actionsList['accountWalletDashboardBtn'])) && (
        <Wallet
          origin="digitalAccount"
          accDetails={accountDetails}
          data={accountDetails.wallets}
          blocks={accountDetails.blocks}
        />
      )}
    </PageContainer>
  );
};

const useStyles = makeStyles(() => ({
  root: {},
  card1: {
    marginBottom: 20,
    paddingBottom: 25,
  },
}));

export default DigitalAccount;
